import React, { useEffect } from "react";
import { useSearchBar } from "./context/SearchBarContext";

const ShowSearchBar = ({ children, defaultValue = "", cleanWhenHide = true }) => {
  const { setSearchBarVisible, setSearchBarText } = useSearchBar();

  useEffect(() => {
    setSearchBarText(defaultValue);
    setSearchBarVisible(true);

    return () => {
      setSearchBarVisible(false);
      if (cleanWhenHide) {
        setSearchBarText("");
      }
    };
  }, [cleanWhenHide, setSearchBarText, setSearchBarVisible]);

  return <>{children}</>;
};

export default ShowSearchBar;
